import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { Invitation } from 'src/features/userManagement/types';

const RESOURCE = '/parkings/:parkingId/invitations/:invitationId/';

interface DTO {
    parkingId: string;
    invitationId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, invitationId }: DTO): Promise<Invitation> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, invitationId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { RESOURCE as GET_INVITATION_RESOURCE, queryFn as getInvitation, useQueryHook as useGetInvitation };
export type { DTO as GetInvitationDTO };
